/**
 * SEO Sprint 4 — Destination page: Curaçao (/shipping-to-curacao).
 *
 * Curaçao is gemigreerd vanuit de oude `ServicePageTemplate` naar de
 * nieuwe destinations-factory (Sprint 2/3) zodat het exact dezelfde
 * UX, structuur, CMS-beheer en schema-implementatie krijgt als
 * Aruba, Bonaire, Sint Maarten en Suriname.
 *
 * CMS-driven via `destination_page_settings` slug=curacao.
 *
 * Backwards compat: oude `service_pages_settings` entries blijven
 * intact in MongoDB (geen destructieve migratie) maar worden niet
 * meer gebruikt voor deze route.
 */
import React from "react";
import DestinationPage from "../components/DestinationPage";

const CURACAO_FALLBACK = {
  display_name: "Curaçao",
  country_code: "CW",
  url_path: "/shipping-to-curacao",
  page_banner: {
    eyebrow: "Bestemming: Curaçao",
    title: "Verzenden naar",
    highlight: "Curaçao",
    subtitle:
      "Onze grootste en meest gebruikte cargo-route. Pakketten, verhuisgoederen, zakelijke cargo en online aankopen van Nederland naar Curaçao — geregeld door één team, met tracking via Mijn 5999Cargo.",
    badges: [
      { icon: "ship",    label: "Zee- en luchtvracht" },
      { icon: "package", label: "Pakketten t/m cargo" },
      { icon: "support", label: "Persoonlijke begeleiding" },
    ],
    cta_primary_label: "Vraag offerte aan",
    cta_primary_url: "/contact?get-quote=1#quote-form",
    cta_secondary_label: "Bel ons",
    cta_secondary_url: "tel:+31488235999",
  },
  intro: {
    eyebrow: "Over verzendingen naar Curaçao",
    title: "Hoe wij uw zending naar Curaçao regelen",
    body:
      "Curaçao is voor 5999Cargo de meest gebruikte cargo-route vanuit Nederland — voor families, ondernemers, emigratie- en verhuiszendingen.\n\nPakketten en spoedgoederen gaan doorgaans via luchtvracht; voor verhuisgoederen, voertuigen en grotere volumes is zeevracht meestal voordeliger via groupage of een complete container.\n\nBeschikbaarheid, tarieven en procedures kunnen per type zending verschillen. Vraag actuele routebeschikbaarheid aan — onze medewerkers helpen u graag met de juiste verzendoptie.",
  },
  service_blocks: { items: [] },
  process_steps: { items: [] },
  trust_signals: { items: [] },
  faq: { items: [] },
  cta_band: {
    title: "Klaar om naar Curaçao te verzenden?",
    description:
      "Vraag een vrijblijvende offerte aan met uw zendingdetails — wij adviseren binnen 1 werkdag de juiste route, kosten en documenten.",
    cta_primary_label: "Vraag offerte aan",
    cta_primary_url: "/contact?get-quote=1#quote-form",
    cta_secondary_label: "Bel ons",
    cta_secondary_url: "tel:+31488235999",
  },
  seo: {
    title: "Pakket naar Curaçao sturen | Zee- en luchtvracht | 5999Cargo",
    description:
      "Verzend pakketten, dozen, verhuisgoederen en cargo van Nederland naar Curaçao. Zee- en luchtvracht, pickup, documenten en aflevering — geregeld door 5999Cargo.",
    keywords:
      "pakket naar Curaçao sturen, zeevracht Curaçao, luchtvracht Curaçao, verhuizen naar Curaçao, vracht naar Curaçao, shipping to Curaçao from Netherlands",
  },
};

export default function ShippingToCuracaoPage() {
  return <DestinationPage slug="curacao" fallback={CURACAO_FALLBACK} />;
}
